import React, { useEffect, useState } from 'react';
import '../../../CSS/Herramientas.css'
import { useNavigate } from 'react-router';
import axios from 'axios';
import {URI, getPermission} from "../../../Conexiones/Conexion"
import { FaTools} from "react-icons/fa";
import { IoArrowUndo } from "react-icons/io5";
import { getToken } from '../../../Conexiones/Conexion';

function AdmonHerramientas() {
    const dataobras =[
        {id:1,nombre: "ENTRADA DE HERRAMIENTAS A OBRA",nameIcon: "iconoES" ,enlace: "Entrada-Herramientas"},
        {id:2,nombre: "SALIDA DE HERRAMIENTAS DE OBRA",nameIcon: "iconoES2",enlace: "Salida-Herramientas"},  
    ]
    const navigate = useNavigate()
    const [obra,setObra] = useState('')
    const usuario = JSON.parse(sessionStorage.getItem('user')) 
    const idUsuario = usuario[0].idUsuario

    useEffect(() => {
        const getObras = async () => {
        const permiso = await getPermission(idUsuario,25);
        if(permiso){
            const obraId = parseInt(sessionStorage.getItem("obra"))
            const res = await axios.get(URI+'obras/'+obraId,{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setObra(res.data.nombreObra);
        }else{
            navigate('/inicio')
        }
        };
        getObras();
    });

    const select = (direccion) => {
        navigate(direccion)
    }

    const regresar = () => {
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras/')
    }

    return (
        <div className='herramientas' >
            <div>
                <h3 className='tituloGastos'>ADMINISTRACION DE HERRAMIENTAS</h3>
                <IoArrowUndo title="REGRESAR" onClick={regresar} style={{position:'absolute', right:'40px', top:'60px', fontSize:'40px', cursor:'pointer', color:'#1A2E4F'}}/>
            </div>
            <div>
                <h4 className='text-uppercase'>{obra}</h4>
            </div>
            <div style={{padding:'20px', textAlign:'center'}}>
                <div className="row gx-5" >
                    {dataobras.map((obras,idx) =>{
                        return(                            
                            <div className="col  align-self-center " key={obras.id}>
                               <div className='card btncolor btn' style={{ marginTop: '20px', textAlign: "center", padding:'10px', fontSize:'25px'}} onClick={() => select(obras.enlace)}>
                                    <div >
                                        <div style={{justifyContent:'center'}}>{obras.nombre}</div>
                                        <div style={{justifyContent:'center',display:"flex"}}>
                                            <div className='circulo'>
                                                <span className={obras.nameIcon}>
                                                    <FaTools />
                                                </span>
                                            </div>
                                        </div>
                                    </div>         
                                </div>
                            </div>
                        )           
                    })}            
                </div>
            </div>
        </div>
    );
}

export default AdmonHerramientas;